interface BrandLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showWordmark?: boolean;
  wordmarkClassName?: string;
}

export function BrandLogo({
  className = '',
  size = 'md',
  showWordmark = true,
  wordmarkClassName = '',
}: BrandLogoProps) {
  const sizeMap = {
    sm: { iconSize: 28, fontSize: 12, gap: 'gap-2' },
    md: { iconSize: 36, fontSize: 15.5, gap: 'gap-2.5' },
    lg: { iconSize: 48, fontSize: 21, gap: 'gap-3' },
  };

  const { iconSize, fontSize, gap } = sizeMap[size] || sizeMap.md;

  return (
    <div
      aria-label="TradeFluency"
      className={`inline-flex items-center ${gap} select-none ${className}`}
    >
      {/* TradeFluency Vector Brand Mark */}
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="shrink-0 transition-transform duration-200 group-hover:scale-105 drop-shadow-[0_2px_8px_rgba(56,189,248,0.25)]"
      >
        <defs>
          <linearGradient id="tf-gradient-primary" x1="2" y1="4" x2="34" y2="32" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#38bdf8" />
            <stop offset="50%" stopColor="#60a5fa" />
            <stop offset="100%" stopColor="#2563eb" />
          </linearGradient>
          <linearGradient id="tf-gradient-accent" x1="12" y1="6" x2="28" y2="22" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#a5f3fc" />
            <stop offset="100%" stopColor="#38bdf8" />
          </linearGradient>
          <linearGradient id="tf-badge-rim" x1="0" y1="0" x2="36" y2="36" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#94a3b8" />
            <stop offset="40%" stopColor="#38bdf8" />
            <stop offset="100%" stopColor="#1e293b" />
          </linearGradient>
        </defs>

        {/* Outer squircle/badge */}
        <rect
          x="1"
          y="1"
          width="34"
          height="34"
          rx="9"
          fill="#080d16"
          stroke="url(#tf-badge-rim)"
          strokeWidth="1.5"
        />

        {/* Dynamic Fluent Chevron / T-F Bars */}
        <rect x="7.5" y="10" width="3.5" height="16" rx="1.75" fill="url(#tf-gradient-primary)" />
        <path
          d="M7.5 11.5C7.5 10.67 8.17 10 9 10H22C22.83 10 23.5 10.67 23.5 11.5V12C23.5 12.83 22.83 13.5 22 13.5H9C8.17 13.5 7.5 12.83 7.5 12V11.5Z"
          fill="url(#tf-gradient-primary)"
        />
        {/* Ascending fluency pulse / trend arrow */}
        <path
          d="M15 22.5L20 17.5L24 20.5L28.5 14"
          stroke="url(#tf-gradient-accent)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="28.5" cy="14" r="2" fill="#38bdf8" />
      </svg>

      {showWordmark && (
        <>
          <span className="sr-only">TradeFluency</span>
          <div
            aria-hidden="true"
            style={{ height: `${iconSize}px` }}
            className={`flex flex-col justify-between items-start text-left select-none leading-none ${wordmarkClassName}`}
          >
            <span
              style={{ fontSize: `${fontSize}px`, lineHeight: 1 }}
              className="font-bold tracking-tight text-white leading-none text-left"
            >
              Trade
            </span>
            <span
              style={{ fontSize: `${fontSize}px`, lineHeight: 1 }}
              className="font-bold tracking-tight text-[#38bdf8] leading-none text-left"
            >
              Fluency
            </span>
          </div>
        </>
      )}
    </div>
  );
}

export default BrandLogo;
